export const ALPHA_NUMERIC_UNDERSCORE_REGEX = /^[a-zA-Z0-9_]+$/ //NOTE: validates alpha numeric characters and underscore

export const MINIMUM_LENGTH_OF_USERNAME = 5

export const MAXIMUM_LENGTH_OF_USERNAME = 50
